import axios from 'axios'
import api from './api'
import Vue from 'vue';
let Base64 = require('js-base64').Base64;
import { Toast } from 'vant';
import qs from "qs";

Vue.use(Toast);

//创建axios实例对象
const instance = axios.create({
    baseURL: '/api', //统一走同域代理
    timeout: 5000, //默认超时时长
    withCredentials: true, 
})

//请求拦截器
instance.interceptors.request.use(config => {
    if (config.method === "post") {
        config.headers = {
            'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
        }
    }
    config.headers = {
        ...config.headers,
        'lang': localStorage.getItem("lang") || 'hk',
    }
    if (localStorage.getItem('token')) {
        config.headers = {
            ...config.headers, 
            'token': Base64.encode(String(localStorage.getItem('token'))),
        }
    }
    return config
}, err => {
    console.error('请求失败', err)
})

//响应拦截器
instance.interceptors.response.use(res => {
    if (res.data.msg === "鉴权错误") {
        // localStorage.clear();
    }
    return res
}, err => {
    return Promise.reject(err);
})

//封装axios请求方法
async function http(option = {}) {
    let result = null
    if (option.method === 'get' || option.method === 'delete') {
        await instance[option.method](
            api[option.url],
            { params: option.data }
        ).then(res => {
            result = res.data;
            if (typeof result.data === 'string') {
                try {
                    result.data = JSON.parse(Base64.decode(result.data));
                } catch(e) { /* ignore */ }
            }
        }).catch(err => {
            result = err;
        })
    } else if (option.method === 'post' || option.method === 'put') {
        await instance[option.method](
            api[option.url],
            qs.stringify(option.data)
        ).then(res => {
            result = res.data;
            if (typeof result.data === 'string') {
                try {
                    result.data = JSON.parse(Base64.decode(result.data));
                } catch(e) { /* ignore */ }
            }
        }).catch(err => {
            if (err.response && err.response.data && err.response.data.code) {
                result = err.response.data;
                if (typeof result.data === 'string') {
                    try { result.data = JSON.parse(Base64.decode(result.data)); } catch(e) { /* ignore */ }
                }
            } else {
                result = { code: err.response ? err.response.status : 500, msg: err.message }
            }
        })
    }
    return result
}

export default http
